import React from "react";
import { Tag } from "antd";
import { CopyOutlined, DeleteRowOutlined, FileExclamationOutlined } from "@ant-design/icons";
import { SyncOutlined, CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

import { Status } from "models";

interface IGenericProps {
  status: Status;
}

const Generic: React.FC<IGenericProps> = ({ status }) => {
  return (
    <React.Fragment>
      {status?.toLowerCase() === "extracted" ? (
        <Tag
          color="cyan"
          icon={<CopyOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status.toLowerCase()}
        </Tag>
      ) : status?.toLowerCase() === "processing" ? (
        <Tag
          color="blue"
          icon={<SyncOutlined spin />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status.toLowerCase()}
        </Tag>
      ) : status?.toLowerCase() === "pushed" ? (
        <Tag
          color="success"
          icon={<CheckCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status.toLowerCase()}
        </Tag>
      ) : status?.toLowerCase() === "extraction_initiated" ? (
        <Tag color="gold" style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}>
          extraction initiated
        </Tag>
      ) : status?.toLowerCase() === "partly_extracted" ? (
        <Tag
          color="volcano"
          icon={<DeleteRowOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          partly extracted
        </Tag>
      ) : status?.toLowerCase() === "not_valid" ? (
        <Tag
          color="error"
          icon={<CloseCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          not valid
        </Tag>
      ) : status?.toLowerCase() === "extracted_with_error" ? (
        <Tag
          color="gold"
          icon={<FileExclamationOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          extracted with error
        </Tag>
      ) : (
        <Tag
          color=""
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            textAlign: "center",
            display: status ? "inline" : "none",
          }}
        >
          {status?.toLowerCase()}
        </Tag>
      )}
    </React.Fragment>
  );
};

export default Generic;
